module.exports = __webpack_public_path__ + "static/media/17d38e26-7d4e-4c6d-b712-a6e5d5f2bba5.92886e77.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/17d38e26-7d4e-4c6d-b712-a6e5d5f2bba5.jpg
// module id = 802
// module chunks = 0